export default __webpack_public_path__ + "static/media/land.23ec29c5.svg";